<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("RequesterName") }}</th>
                  <th style="width: 14%">{{ $t("RequesterUsername") }}</th>
                  <th style="width: 10%">{{ $t("Departman") }}</th>
                  <th style="width: 13%">{{ $t("DeliveryDate") }}</th>
                  <th style="width: 13%">{{ $t("CreateOn") }}</th>
                  <th style="width: 10%">{{ $t("CurrencyType") }}</th>
                  <th style="width: 40%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 20%">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 13%">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <td style="width: 13%">
                    <v-select
                      class="m-0"
                      label="name"
                      name="unit"
                      :options="allCurrency"
                      v-model="model.currencyType"
                      :reduce="(x) => x.id"
                      :disabled="!editCurrencyClicked"
                      dir="rtl"
                    >
                    </v-select>
                  </td>
                  <td style="width: 33%">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.purchaseItems && model.purchaseItems.length > 0"
          >
            <vs-table :data="model.purchaseItems" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                <th style="width: 14%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("UnitPrice") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Amounts") }}</th>
                <!-- <th style="width: 10%">{{ $t("Action") }}</th> -->
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td style="width: 25%">
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td style="width: 20%">
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td style="width: 15%">
                    <vs-input
                      v-model="row.purchaseOrderProductInfo.itemCode"
                      name="modelNumber"
                      :disabled="!editItemCodeClicked"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-input
                      v-model="row.unitPrice"
                      :disabled="!editUnitClicked"
                    />
                  </vs-td>
                  <vs-td>
                    {{ row.unitOfMeasuresName }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <!-- <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteProduct(index)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end w-full">
            <div class="ml-4">
              <vs-button
                v-if="editCurrencyClicked"
                type="filled"
                @click.prevent="saveCurrency"
              >
                <span> {{ $t("SaveCurrencyType") }}</span>
              </vs-button>
              <vs-button v-else type="filled" @click.prevent="editCurrency">
                <span> {{ $t("EditCurrencyType") }}</span>
              </vs-button>
            </div>
            <div class="ml-4">
              <vs-button
                v-if="editUnitClicked"
                type="filled"
                @click.prevent="saveUnit"
              >
                <span> {{ $t("SaveUnitPrice") }}</span>
              </vs-button>
              <vs-button v-else type="filled" @click.prevent="editUnit">
                <span> {{ $t("EditUnitPrice") }}</span>
              </vs-button>
            </div>
            <div class="ml-4">
              <vs-button
                v-if="editItemCodeClicked"
                type="filled"
                @click.prevent="saveItemCode"
              >
                <span> {{ $t("SaveItemCode") }}</span>
              </vs-button>
              <vs-button v-else type="filled" @click.prevent="editItemCode">
                <span> {{ $t("EditItemCode") }}</span>
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full ml-4 mt-10">
      <vs-button type="filled" color="danger" @click.prevent="reject">
        <span> {{ $t("Reject") }}</span>
      </vs-button>
      <vs-button
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Close") }}</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    "v-select": vSelect,
  },
  data() {
    var id = this.$route.params.id;

    return {
      allUnits: [],
      allCurrency: [
        { name: "ریال", id: 1 },
        { name: "دلار", id: 2 },
        { name: "درهم", id: 3 },
      ],
      headerInfo: {},
      model: {},
      editable: true,
      editItemCodeClicked: false,
      editUnitClicked: false,
      editCurrencyClicked: false,
      productName: "",
      modelNumber: "",
      amount: null,
      unit: {},
    };
  },
  //   computed: {
  //     ...mapGetters({
  //       headerInfo: "purchaseRequest/details",
  //     }),
  //   },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPerInvoice: "perInvoice/fetchPerInvoice",
      editPurchaseRequest: "perInvoice/editPurchaseRequest",
      acceptPurchaseRequest: "perInvoice/acceptPurchaseRequest",
      closePreInvoice: "perInvoice/closePreInvoice",
      saveCurrencyFunction: "perInvoice/saveCurrency",
      saveUnitFunction: "perInvoice/saveUnitPrice",
      saveItemCodeFunction: "perInvoice/saveItemCode",
      fetchUnits: "unit/fetchList",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchPerInvoice(id).then((r) => {
        this.model = r;
      });
      this.fetchUnits().then((r) => {
        this.allUnits = r;
      });
    },

    editItemCode() {
      this.editItemCodeClicked = true;
      this.editUnitClicked = false;
      this.editCurrencyClicked = false;
    },
    editUnit() {
      this.editUnitClicked = true;
      this.editCurrencyClicked = false;
      this.editItemCodeClicked = false;
    },
    editCurrency() {
      this.editCurrencyClicked = true;
      this.editUnitClicked = false;
      this.editItemCodeClicked = false;
    },
    saveItemCode() {
      const payload = {
        purchaseOrderId: this.model.id,
        purchaseOrderItems: this.model.purchaseItems,
      };
      this.saveItemCodeFunction(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "کد کالا مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.load();
          this.editItemCodeClicked = false;
        }).catch(()=>{
          this.load();
          console.log('error')
        });
      });
    },
    saveUnit() {
      const payload = {
        purchaseOrderId: this.model.id,
        purchaseOrderItems: this.model.purchaseItems,
      };
      this.saveUnitFunction(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "فی مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.load();
          this.editUnitClicked = false;
        }).catch(()=>{
          this.load();
          console.log('error')
        });
      });
    },
    saveCurrency() {
      const payload = {
        id: this.model.id,
        currencyType: this.model.currencyType,
      };
      console.log(payload)
      this.saveCurrencyFunction(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "نوع ارز مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.editCurrencyClicked = false;
        }).catch(()=>{
          console.log('error')
        });
      });
    },
    addProduct() {
      const product = {
        productName: this.productName,
        modelNumber: this.modelNumber,
        unitOfMeasuresName: this.unit.name,
        count: this.amount,
      };
      this.model.purchaseItems.push(product);
    },
    save() {
      const payload = {
        id: this.model.id,
        deliveryClock: this.model.persianDeliveryClock,
        description: this.model.description,
        purchaseItems: this.model.purchaseItems,
      };
      this.editPurchaseRequest(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "درخواست خرید مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.editable = true;
          this.editClicked = false;
        });
      });
    },
    deleteProduct(index) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.model.purchaseItems.splice(index, 1);
        }
      });
    },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این درخواست اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectPreInvoice({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "سفارش خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      this.closePreInvoice({ id: this.model.id }).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "سفارش خرید مورد نظر تایید شد",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
